import logoImage from "@/assets/loopbaan-logo.png";

interface LogoProps {
  className?: string;
}

export const Logo = ({ className = "h-6 w-6" }: LogoProps) => {
  return (
    <img 
      src={logoImage} 
      alt="LoopBaan.ai Logo" 
      className={className}
    />
  );
};
